import React from 'react';
import classNames from 'classnames';
import { testId } from '@jwp/ott-common/src/utils/common';

import Modal from '../Modal/Modal';
import Slide from '../Animation/Slide/Slide';
import ModalCloseButton from '../ModalCloseButton/ModalCloseButton';

import { useTheme } from '../../../../../ThemeContext';

import styles from './Dialog.module.scss';

type Props = {
  open: boolean;
  onClose: () => void;
  size?: 'small' | 'large' | 'subscription' | 'extra-large';
  children: React.ReactNode;
  role: React.AriaRole;
  shouldNotCloseButton?: boolean;
} & React.AriaAttributes;

const Dialog: React.FC<Props> = ({ open, onClose, children, size = 'small', role = 'dialog', shouldNotCloseButton, ...ariaAttributes }: Props) => {
  const { universalStyles } = useTheme();
  return (
    <Modal open={open} onClose={onClose} AnimationComponent={Slide} role={role} centered elevation="high">
      <div
        className={classNames(styles.dialog, styles[size])}
        aria-modal="true"
        aria-label="Dialog"
        data-testid={testId('dialog')}
        {...ariaAttributes}
        style={universalStyles.modalBackgroundColors}
      >
        {children}
        {shouldNotCloseButton ? <ModalCloseButton onClick={onClose} /> : null}
      </div>
    </Modal>
  );
};

export default Dialog;
